mutation DuplicateEmoteWall($emoteWallId: ID!) {
  wall: StreamToolsDuplicateEmoteWall(emoteWallId: $emoteWallId) {
    emoteWallId
    name
    twitchChatChannels
    style
    emoteSize
    density
    durationSeconds
    showTwitchEmotes
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    youtubeChatChannels
    blockedWords
    createdAt
  }
}
